import { ApiEndPoints, NetworkManager } from "../network";

export class HospitalService {
    static addHospital = (hospital) => {
        return NetworkManager.getInstance().appRequest({
          method: "post",
          url: ApiEndPoints.hospitals,
          data: { ...hospital },
        });
      };

      static getAllHospitals = () => {
        return NetworkManager.getInstance().appRequest({
          method: "get",
          url: ApiEndPoints.hospitals
        });
      };
    
      static updateHospital = (hospital) => {
        return NetworkManager.getInstance().appRequest({
          method: "put",
          url: ApiEndPoints.hospitals,
          data: { ...hospital },
        });
      };

      static deleteHospital = (id) => {
        return NetworkManager.getInstance().appRequest({
          method: "delete",
          url: ApiEndPoints.hospitals + "/" + id,
          data: { ...id },
        });
      };

      static verifyHospitalEmail = (emailId) => {
        return NetworkManager.getInstance().appRequest({
          method: "get",
          url: `${ApiEndPoints.hospitals}/verify-email?emailId=${encodeURIComponent(emailId)}`,
        });
      };

      static updateHospitalPassword = (hospital) => {
        return NetworkManager.getInstance().appRequest({
          method: "put",
          url: ApiEndPoints.hospitals + "/password",
          data: { ...hospital },
        });
      };
}